import { Injectable } from '@angular/core';
import CryptoJS from "crypto-js";
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CryptoService {
  CRYPTO_KEY = environment.crypto_key;

  key: string = '';

  constructor(
  ) {
  }

  public encrypt(value) {
      return CryptoJS.AES.encrypt(value, this.CRYPTO_KEY).toString();
  }

  public decrypt(value) {
    let bytes  = CryptoJS.AES.decrypt(value, this.CRYPTO_KEY);
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  }
}
